{
  "sections": {
    "hero": "Portfolio",
    "about": "About",
    "experience": "Experience",
    "education": "Education",
    "skills": "Skills",
    "projects": "Projects",
    "talks": "Talks",
    "contact": "Contact"
  },
  "hero": {
    "headline": "Frontend Developer",
    "description": "Web crafter, building accessible and performant websites with a focus on user experience."
  },
  "about": {
    "headline": "A little about me",
    "paragraphs": [
      "I first started programming by dabbling with digital television applications back in 2011, and since then I never stopped. I had the opportunity to learn a variety of languages at the university, from C and C++ to SML and VHDL, but I found my passion in web development, where I can combine my creativity with my technical skills to create engaging experiences for users.",
      "I have more than {programming} years of programming and {professional} years of professional experience in web development with JavaScript/TypeScript, where I have worked with many technologies and frameworks including Vue, Angular, Nuxt, and Astro. I have also occasionally worked with back-end technologies such as .NET Core, Django, and Node."
    ]
  },
  "experience": [
    {
      "title": "Ecosia",
      "link": "https://ecosia.org",
      "duration": "apr 2021 - present",
      "intro": "Front-end Engineer",
      "description": "Working as a front-end engineer for the search engine that plants trees. I use JavaScript with Vue, Nuxt and Vite, as well as HTML and SCSS to create web pages, both static and server-side. I evaluate the performance and accessibility of these pages, ensure their integrity through testing, and make sure we deliver enjoyable experiences to our users."
    },
    {
      "title": "Symbaros",
      "link": "https://symbaros.com.br",
      "duration": "aug 2020 - mar 2022",
      "intro": "Consultant",
      "description": "Worked as a consultant front-end architect for a platform specialized in the rental of commercial space using artificial intelligence. I chose the technology and architecture for all the web pages, using VueJS as a base, and created integrations with APIs to retrieve information relating to property searches and their attributes."
    },
    {
      "title": "Questrade",
      "link": "https://www.questrade.com/home",
      "duration": "june 2020 - dec 2020",
      "intro": "Front-end Engineer",
      "description": "Worked as a front-end engineer for a Canadian financial platform specializing in trading, using TypeScript, Angular8+, and SCSS to deliver high-performance and secure experiences to its users."
    },
    {
      "title": "Blip.ai",
      "link": "https://blip.ai",
      "duration": "june 2019 - may 2020",
      "intro": "Full Stack Developer",
      "description": "Worked as a full stack developer on the chatbot-building platform BLiP.ai, using AngularJS and VueJS for the front-end, .NET Core for the back-end, and Python for parsing Natural Language Processing models, as well as creating an API in Django to enable queries to trained models."
    },
    {
      "title": "Blip.ai",
      "link": "https://blip.ai",
      "duration": "jan 2018 - may 2019",
      "intro": "Development Intern",
      "description": "Worked as a computer science intern on the chatbot-building platform BLiP.ai using AngularJS and VueJS frameworks, provided solutions on artificial intelligence using Python, and analyzed Natural Language Processing models based on intentions and entities."
    }
  ],
  "education": {
    "institution": "Universidade Federal de Minas Gerais (UFMG)",
    "year": "2021",
    "degree": "Bachelor's Degree",
    "field": "Computer Science"
  },
  "skills": {
    "programming": "Programming",
    "web": {
      "title": "Web",
      "set": [
        "Performance",
        "Accessibility",
        "Responsivity"
      ]
    },
    "frameworks": "Frameworks",
    "tools": "Tools",
    "testing": "Testing",
    "databases": "Databases",
    "languages": {
      "title": "Languages",
      "set": [
        "English (Fluent)",
        "Portuguese (Native)",
        "French (Competent)"
      ]
    }
  },
  "projects": [
    {
      "name": "Altomata",
      "image": "altomata.gif",
      "link": "https://altomata.github.io",
      "description": "A cellular automata simulator built with VueJS and TypeScript, allowing users to create and visualize cellular automata rules, patterns and evolutions."
    }
  ],
  "talks": [
    {
      "event": "The Developer's Conference",
      "link": "https://thedevconf.com/tdc/2019/belohorizonte/trilha-inteligencia-artificial",
      "date": "June 14th 2019",
      "title": "Word Embedding and Application",
      "description": "How to develop an application to solve a recurring Natural Language Processing problem using the Word Embedding algorithm? We are going to explore the spell check task."
    },
    {
      "event": "Developer Circle",
      "link": "https://thedevconf.com/tdc/2019/belohorizonte/trilha-inteligencia-artificial",
      "date": "Feb 19th 2019",
      "title": "How To Learn Using Text?",
      "description": "To use words in mathematical models, we rely on transforming them into some form of numerical representation. One of many algorithms that perform such task is the Word Embedding."
    }
  ],
  "read": "Read",
  "contact": {
    "prompt": "Let's talk.",
    "description": "If you represent a non-profit organization in search of volunteers, or are part of an underprivileged or discriminated group in need of mentorship, I'll be happy to lend a hand."
  },
  "footer": {
    "rights": "All rights reserved."
  }
}
